var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDiggLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 55.868,
    height: 55.868,
    viewBox: "0 0 55.868 55.868",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.106,
    y1: 0.937,
    x2: 0.931,
    y2: 0.107,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9149ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e600ff"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3939",
    "data-name": "Group 3939",
    transform: "translate(13036 -8627)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2425",
    "data-name": "Path 2425",
    d: "M48.38,27.243,40.066,38.9l-8.191-5.149a3.1,3.1,0,0,0-4.336.609L16.98,47.644l0,0a3.116,3.116,0,0,0,.5,4.38,3.05,3.05,0,0,0,1.932.686,3.18,3.18,0,0,0,2.474-1.289L30.2,40.867s8.29,5.272,8.443,5.379a3.1,3.1,0,0,0,4.312-.755l10.5-14.55V30.88a3.121,3.121,0,1,0-5.072-3.637",
    transform: "translate(-13043.303 8615.452)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2426",
    "data-name": "Path 2426",
    d: "M35.552,2.813a17.522,17.522,0,0,1,17.5,17.5V35.552a17.522,17.522,0,0,1-17.5,17.5H20.316a17.522,17.522,0,0,1-17.5-17.5V20.316a17.522,17.522,0,0,1,17.5-17.5Zm0-2.813H20.316A20.316,20.316,0,0,0,0,20.316V35.552A20.316,20.316,0,0,0,20.316,55.868H35.552A20.316,20.316,0,0,0,55.868,35.552V20.316A20.316,20.316,0,0,0,35.552,0",
    transform: "translate(-13036 8627)",
    fill: "#4d4d4d"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiggLogo);
export default __webpack_public_path__ + "static/media/DiggLogo.2938c3fb28ea8f4a803e2e141acf378e.svg";
export { ForwardRef as ReactComponent };